import { Controller } from "@hotwired/stimulus"

// The iOS share extension hands over a link (TikTok, a recipe site) or a block
// of recipe text from another app. The app opens this page and passes it in
// as window.__recidexSharedImport, or fires recidex:shared-import if the page
// was already open. Fill the matching form and submit it, so a share goes
// straight to "Review and save". Only native code can set either, so a web
// link can't trigger an import.
export default class extends Controller {
  static targets = ["url", "text"]

  connect() {
    const pending = window.__recidexSharedImport
    delete window.__recidexSharedImport
    if (pending) this.import(pending)
  }

  receive(event) {
    delete window.__recidexSharedImport
    this.import(event.detail)
  }

  import({ kind, value, page }) {
    if (!["url", "text"].includes(kind) || typeof value !== "string") return

    const field = kind === "text" ? this.textTarget : this.urlTarget
    field.value = value
    // Lets the server record the recipe's origin as shared_link / shared_paste,
    // so the admin funnel shows how often the share sheet is used.
    this.setHidden(field.form, "shared", "1")
    // A link shared from Safari comes with the page as the person sees it,
    // which reads even a site that turns our server away.
    if (kind === "url" && typeof page === "string") this.setHidden(field.form, "page", page)
    field.form.requestSubmit()
  }

  setHidden(form, name, value) {
    let input = form.querySelector(`input[name=${name}]`)
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      form.append(input)
    }
    input.value = value
  }
}
